<!-- <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="">
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div class="form-group ">
                <div class="d-flex justify-content-between align-items-center">
                    <label for="email">Email</label>
                    <a href="javascript:void(0)" (click)="forgotEmail()" class="text-decoration-none">Forgot email?</a>
                </div>
                <input type="email" id="email" formControlName="email" class="form-control" required
                    placeholder="user@example.com" tabindex="0" [ngClass]="{
                  'is-invalid': loginForm.get('email')?.touched && loginForm.get('email')?.invalid
                }" />
                <div *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.errors as errors">
                    <div *ngIf="errors['required']" class="text-danger mt-1 err-font">Email is required</div>
                    <div *ngIf="!errors['required'] && errors['email']" class="text-danger mt-1 err-font">
                        Please enter a valid email address
                    </div>
                </div>
            </div>
            <div class="form-group">
                <div class="d-flex justify-content-between align-items-center">
                    <label for="password">Password</label>
                    <a href="javascript:void(0)" (click)="forgotPassword()" class="text-decoration-none">Forgot
                        password?</a>
                </div>
                <div class="input-group pwd-input-group">
                    <input type="showPassword ? 'text' : 'password'" id="password" class="form-control pwd-input"
                        required formControlName="password" tabindex="0" placeholder="Enter your password" [ngClass]="{
                    'is-invalid': loginForm.get('password')?.touched && loginForm.get('password')?.invalid
                  }" />
                    <span class="pwd-eye">
                        <button class="btn p-0 eye pi pi-eye" tabindex="0"
                            [ngClass]="{ 'pi-eye': showPassword, 'pi-eye-slash': !showPassword }"
                            (click)="togglePassword()" (keypress)="togglePassword()"
                            title="{{ showPassword ? 'Hide Password' : 'Show Password' }}"
                            aria-label="Show/hide Password" id="showHidePassword"></button>
                    </span>
                </div>
                <div *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.errors as errors">
                    <div *ngIf="errors['required']" class="text-danger mt-1 err-font">Password is required</div>

                </div>

            </div>
            <div class="form-group mt-4">
                <button type="submit" class="btn-primary d-flex justify-content-center">Log In <span class="material-symbols-outlined">
                        arrow_outward
                    </span></button>
            </div>
        </form>
    </div>
</div> -->

<div class="row login" style="height: 100vh;">
    <div class="col-lg-5 col-md-5 align-items-center p-0 bg-white" style="height: 100%; position: relative; z-index: 2;">
        <div class="bg-white" style="height: 100%;">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 p-5" style="height: 100%;">
                <div class="d-flex justify-content-center mt-5 mb-5">
                    <img id="logo" src="../assets/images/edu-logo.svg" alt="NDE_logo" style="width: 100%; height: auto;">
                </div>
                <div class="loginBottomSet clearfix mb-5">
                    <h1 class="pt-5">Sign In</h1>
                    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                        <div class="form-group">
                            <label for="email">Email Address</label>
                            <a href="javascript:void(0)" (click)="forgotEmail()" class="text-decoration-none d-flex justify-content-end">Forgot Email?</a>
                            <input type="email" id="email" formControlName="email" class="form-control" required
                                placeholder="Please enter your Email Address" tabindex="0" [ngClass]="{
                              'is-invalid': loginForm.get('email')?.touched && loginForm.get('email')?.invalid
                            }" />
                            <div *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.errors as errors">
                                <div *ngIf="errors['required']" class="text-danger mt-1 err-font">Email is required</div>
                                <div *ngIf="!errors['required'] && errors['email']" class="text-danger mt-1 err-font">
                                    Please enter a valid email address
                                </div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="password">Password</label>
                            <a href="javascript:void(0)" (click)="forgotPassword()" class="text-decoration-none d-flex justify-content-end">Forgot your password?</a>
                            <input [attr.type]="showPassword ? 'text' : 'password'" 
                                   id="password" 
                                   formControlName="password" 
                                   class="form-control" 
                                   required
                                   placeholder="Password" 
                                   tabindex="0" 
                                   (keypress)="onPasswordKeyEvent($event)"
                                   (keydown)="onPasswordKeyEvent($event)"
                                   (keyup)="onPasswordKeyEvent($event)"
                                   [ngClass]="{
                              'is-invalid': loginForm.get('password')?.touched && loginForm.get('password')?.invalid
                            }" />
                            <!-- <div class="d-flex justify-content-end">
                                <a class="d-flex justify-content-end" href="javascript:void(0)" (click)="forgotPassword()" class="text-decoration-none">Forgot your password?</a>
                            </div> -->
                            <div *ngIf="capsLockOn" class="text-warning mt-1 err-font">Caps Lock is ON</div>
                            <div *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.errors as errors">
                                <div *ngIf="errors['required']" class="text-danger mt-1 err-font">Password is required</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <button type="submit" class="btn btn-primary w-100" (click)="onSubmit()">Log In<span class="material-symbols-outlined">
                        arrow_outward
                    </span></button>
                        </div>
                    </form>
                    
                    <!-- Divider with "Register as an Educator" in the middle -->
                    <!-- <div class="d-flex align-items-center mt-4 mb-4">
                        <hr class="flex-grow-1">
                        <span class="mx-3 text-muted">or</span>
                        <hr class="flex-grow-1">
                    </div>
                    
                    <div class="text-center">
                        <a [routerLink]="['/reg-form']" class=" w-100 text-decoration-none">Register as an Educator</a>
                    </div> -->

                    <hr>
                    <div class="registerSection" >
                        <p>Are you an educator or licensure applicant who needs to register for an account? <a [routerLink]="['/reg-form']">Click here</a>  </p>
                    </div>
                    <hr>
                        <button class="btn btn-link text-decoration-none btn-label w-100 text-align-center mt-3 rounded-3" (click)="complaintPage()">Raise a Complaint</button>
                </div>
            </div>
        </div>
    </div>

    <div class="col-lg-7 col-md-7 d-flex bg-white p-0" style="height: 100%; position: relative;">
        <div class="rightLoginSet" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; transform: rotate(0deg); opacity: 1;">
            <img id="background-image" src="../assets/images/diverse-group-students-classroom-setting.png" alt="classroom setting" style="width: 100%; height: 100%; object-fit: cover;">
        </div>
        <div class="box-blur" style="bottom: 0; z-index: 1; mask-image: linear-gradient(to top, rgba(0,0,0,1) 60%, rgba(0,0,0,0) 100%); -webkit-mask-image: linear-gradient(to top, rgba(0,0,0,1) 60%, rgba(0,0,0,0) 100%);" alt="blur effect"></div>
        <div class="sub-content mt-3 text-white col-lg-12 col-md-12 p-2 pl-4" style="z-index: 2;">
            <h2>State of Nevada Educator Licensure System</h2>
            <p class="w-80 ">The State of Nevada Educator Licensure System is the official platform where educators can apply for, manage, and renew their teaching licenses in Nevada.</p>
        </div>
    </div>
</div>